import { Paper, Tooltip, TooltipProps as MuiTooltipProps, Typography, TypographyProps } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

export interface TooltipProps extends MuiTooltipProps {
  className?: string;
  disableUnderline?: boolean;
  titleVariant?: TypographyProps['variant'];
  titleTypography?: TypographyProps;
}

const StyledArrivedTooltip = styled((props) => {
  const { children, className } = props;

  return (
    <Tooltip {...props} classes={{ popper: className, tooltip: 'popup-content' }}>
      {children}
    </Tooltip>
  );
})`
  &.arrived-tooltip {
    .arrived-tooltip-inner {
      padding: ${({ theme }) => theme.spacing(2)};
    }

    .tooltip-underline {
      text-decoration: underline dashed;
      text-underline-offset: ${({ theme }) => theme.spacing(0.6)};
      cursor: pointer;
    }

    .popup-content {
      max-width: 500px;
      border: 0;
      margin-top: ${(props) => props.theme.spacing(0.5)} !important;
      background-color: transparent;
      // hide because we wrap content in our own paper element.
      box-shadow: none;
      font-weight: normal;
      transform: translate(-50%, 0);

      .popup-arrow {
        display: none;
      }

      .trade-status-table {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;

        .key-value-row {
          display: flex;
          width: 100%;
          padding: 8px 0;
          border-bottom: 1px solid #bbb;
          text-align: left;

          &:last-child {
            border-bottom: 0;
          }

          .key {
            flex: 0 0 34%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            color: #4d4d4d;
          }

          .value {
            flex: 1 1 66%;
            color: #000;
            text-align: left;
          }
        }
      }
    }
  }
`;

export const ArrivedTooltip = ({
  children,
  className,
  placement,
  title,
  titleVariant,
  titleTypography,
  disableUnderline,
  ...tooltipProps
}: TooltipProps) => {
  return (
    <StyledArrivedTooltip
      className={clsx('arrived-tooltip', className)}
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      placement={placement || 'bottom-start'}
      {...tooltipProps}
      title={
        <Paper elevation={5}>
          <div className="arrived-tooltip-inner">{children}</div>
        </Paper>
      }
    >
      <Typography variant={titleVariant ? titleVariant : 'body1'} component="span" {...titleTypography}>
        <span className={clsx({ 'tooltip-underline': !disableUnderline })}>{title}</span>
      </Typography>
    </StyledArrivedTooltip>
  );
};
